import axios from 'axios';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import FileInput from '../Common-Components/FileInput';

const NEET_PracticeTestBannersModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const initialData = {
        Title: '',
        ImageUrl: '',
        Link: '',
    };
    const [formData, setFormData] = useState(initialData);

    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setFormData({
                    Sn: item.Sn,
                    Title: item.Title || '',
                    ImageUrl: item.ImageUrl || '',
                    Link: item.Link || '',
                });
            } else {
                setFormData(initialData);
            }
            setModalBox(true);
        }
    }));

    const handleSave = async () => {
        try {
            if (!formData.Title?.trim()) {
                toast.error("Please enter a title");
                return;
            }
            if (!formData.ImageUrl?.trim()) {
                toast.error("Please upload an image");
                return;
            }
            if (!formData.Link?.trim()) {
                toast.error("Please enter a link");
                return;
            }

            const payload = {
                ...formData,
                Status: 1
            };

            const url = formData.Sn
                ? '/neet/updatePracticeTestBanner'
                : '/neet/createPracticeTestBanner';

            const response = await axios.post(BACKEND_SERVER_URL + url, payload);
            toast.success(response?.data?.message || 'Saved successfully');
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'Error saving data');
        } finally {
            props.setLoadData(!props.loadData);
            setFormData(initialData);
            setModalBox(false);
        }
    };

    const handleFileInput = (name, value) => {
        setFormData({ ...formData, [name]: value });
    }

    return (
        <Modal onHide={() => setModalBox(false)} show={modalBox} size="md" backdrop="static" keyboard={false}>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title text-primary">{formData.Sn ? "Update" : "Add"} NEET Test Banner</h5>
                    <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                </div>
                <div className="modal-body">
                    <div className="mb-3">
                        <label className="form-label text-primary">Title <span className="required">*</span></label>
                        <input
                            autoFocus
                            className='form-control'
                            type="text"
                            placeholder="e.g. NEET Biology"
                            value={formData.Title}
                            onChange={(e) => setFormData({ ...formData, Title: e.target.value })}
                        />
                    </div>

                    <div className="mb-3 row border rounded py-2 m-0 bg-light">
                        <FileInput
                            labelName="Banner Image"
                            isMandatory={true}
                            inputType={'text'}
                            inputName={'ImageUrl'}
                            accept={"image/png, image/jpeg, image/webp"}
                            uploadedFileURL={formData.ImageUrl}
                            handleChangeCallBack={handleFileInput}
                        />
                    </div>

                    <div className="mb-3 mt-3">
                        <label className="form-label text-primary">Link (URL) <span className="required">*</span></label>
                        <input
                            className='form-control'
                            type="text"
                            placeholder="e.g. /neet/test-series"
                            value={formData.Link}
                            onChange={(e) => setFormData({ ...formData, Link: e.target.value })}
                        />
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                    <button type="button" className="btn btn-primary btn-xs" onClick={handleSave}>
                        {formData.Sn ? "Update" : "Save"}
                    </button>
                </div>
            </div>
        </Modal>
    );
});

export default NEET_PracticeTestBannersModal;
